import { fetch } from '@/utils/http'

export default {
  revokeCert: params => fetch('post', 'v1/cert/revokeCert', params),
  uploadCertificateFile: params => fetch('post', '/cbaas-service/v1/upload/file', params),
  download: params => fetch('get', '/cbaas-service/v1/cert/downloadCert', params),
  getRootList: params => fetch('get', '/cbaas-service/v1/cert/queryCertList', params),
  getCaList: params => fetch('get', '/cbaas-service/v1/cert/queryCaEntityList', params),
  initRoot: params => fetch('post', '/cbaas-service/v1/cert/createCaEntity', params),
  importRootCert: params => fetch('post', '/cbaas-service/v1/cert/importCert', params),
  getCertDetail: params => fetch('get', '/cbaas-service/v1/cert/queryCertContent', params),
  getOrgList: params => fetch('get', '/cbaas-service/v1/cert/queryCertList', params),
  initOrg: params => fetch('post', '/cbaas-service/v1/cert/genCertFromCA', params),
  importOrgCert: params => fetch('post', '/cbaas-service/v1/cert/importCert', params),
  getNodeList: params => fetch('get', '/cbaas-service/v1/cert/queryCertList', params),
  initNode: params => fetch('post', '/cbaas-service/v1/cert/genCertFromCA', params),
  importNodeCert: params => fetch('post', '/cbaas-service/v1/cert/importCert', params),
  getUserList: params => fetch('get', '/cbaas-service/v1/cert/queryCertList', params),
  initUser: params => fetch('post', '/cbaas-service/v1/cert/genCertFromCA', params),
  importUserCert: params => fetch('post', '/cbaas-service/v1/cert/importCert', params),
  getUserListByOrg: params => fetch('get', '/cbaas-service/v1/cert/getCertUserList', params), // 首页订阅区块链使用
  genCert: params => fetch('post', '/cbaas-service/v1/cert/genCert', params),
  genCertAll: params => fetch('post', '/cbaas-service/v1/cert/genCertAll', params),

  //Dpos证书相关
  genDposCert: params => fetch('post', '/cbaas-service/v1/cert/genDposCert', params),//生成Dpos证书
  getDposManagerCerts: params => fetch('get', '/cbaas-service/v1/cert/queryDposAdminCertList', params),//获取管理员证书列表 
  getDposNodeUserCerts: params => fetch('get', '/cbaas-service/v1/cert/queryDposNodeCertList', params),//获取节点用户证书列表 


  //获取Dpos链关联的管理员详情
  getDposChainAdmins: params => fetch('get', '/cbaas-service/v1/chainManagement/queryDposChainAdmin', params),
  //获取Dpos链关联的节点详情
  getDposChainNodes: params => fetch('get', '/cbaas-service/v1/chainManagement/queryDposChainNode', params),
}
